import { DateTime } from 'luxon';
import { FormattedDateTimeRange } from 'react-intl';

interface FormattedTimeRangeProps {
  values: [DateTime, DateTime] | [string, string];
}

export function FormattedTimeRange({ values }: FormattedTimeRangeProps) {
  const dates = values.map(value => (typeof value === 'string' ? DateTime.fromISO(value) : value));

  const fromDate = dates[0] < dates[1] ? dates[0] : dates[1];
  const toDate = dates[0] < dates[1] ? dates[1] : dates[0];

  return (
    <FormattedDateTimeRange
      from={fromDate.toJSDate()}
      to={toDate.toJSDate()}
      hour="numeric"
      minute="numeric"
    />
  );
}
